import { SuportAreaTranslations } from "./suport-area-pt-br";

export const SUPORT_AREA_EN_US: SuportAreaTranslations = {
	title: "Help center",
	questionTitle: "Need help?",
	questionDescription: "Open a ticket and talk to our support team.",
	openTicket: "New ticket",
	close: "Close",
};
